import { BotConnection } from "./bot-connection.model";

export class BotConnectionComplete extends BotConnection {
    icon?: string;

    constructor(other: Partial<BotConnectionComplete>) {
        super(other);
        this.icon = other.icon;
    }
}